import { System, Action, ActionTypes } from "../actions";
const defaultState = {
  navigation: false,
  page_has_sub_nav: false,
  PopupAlerts: null,
};
export const systemReducer = (state: System = defaultState, action: Action) => {
  switch (action.type) {
    case ActionTypes.PAGE_HAS_SUB_NAV:
      return { ...state, page_has_sub_nav: action.payload } as System;
    case ActionTypes.NAVIGATION_TOOGLE:
      return { ...state, navigation: !state.navigation } as System;
    case ActionTypes.PUSH_POPUP_ALERT:
      return {...state, PopupAlerts: state.PopupAlerts === null ? [action.payload] : state.PopupAlerts.concat([action.payload])} as System;
    case ActionTypes.REMOVE_POPUP_ALERT:
      return {...state, PopupAlerts: state.PopupAlerts === null ? null : state.PopupAlerts.filter(itm => state.PopupAlerts !== null && itm.title !== state.PopupAlerts[0].title)} as System;
    default:
      return state;
  }
};
